import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';

/**
 * API
 */
import adminAPI from '@/api/admin';

/**
 * Types
 */
export type IsAuthorizedType = (selector: (p: any) => boolean) => boolean;

/**
 * Module VueX de gestion des permissions des agents.
 */
@Module({
	namespaced: true
})
export default class AgentPermissions extends VuexModule {
	/** State */
	isSuperAdmin: boolean | null = null;
	agentPermissions: any | null = null;

	/** Mutations */
	@Mutation
	FETCH_AGENT_PERMISSIONS_SUCCESS({ isSuperAdmin, permissions }: any) {
		this.isSuperAdmin = isSuperAdmin;
		this.agentPermissions = permissions;
	}

	/** Actions */
	@Action({ commit: 'FETCH_AGENT_PERMISSIONS_SUCCESS' })
	async fetchAgentPermissions() {
		return await adminAPI.getAgentPermissions();
	}

	/** Getters */
	get isAuthorized(): IsAuthorizedType {
		return (selector: (p: any) => boolean) => {
			return this.isSuperAdmin || (this.agentPermissions ? selector(this.agentPermissions) : false);
		};
	}
}
